/*
 * cart-performance.js — telemetria de performance do carrinho (Refresh/Dawn 15.x).
 *
 * Este arquivo faltava no tema: product-form.js, cart.js e global.js chamam
 * CartPerformance.* e, sem ele, um ReferenceError interrompia o fluxo antes de
 * renderContents() — o produto entrava no carrinho mas o drawer não abria, e
 * mudar quantidade / remover item no drawer não funcionava.
 *
 * Como é só instrumentação, nada aqui pode voltar a derrubar o carrinho:
 * toda chamada à Performance API é isolada e measure() sempre executa o
 * callback (e propaga seu retorno), mesmo se a marcação falhar.
 *
 * O guard permite que uma futura atualização oficial do tema substitua esta
 * implementação sem conflito.
 */
if (typeof window.CartPerformance === 'undefined') {
  class CartPerformance {
    static #metricPrefix = 'cart-performance';

    static #metricName(benchmarkName) {
      return `${CartPerformance.#metricPrefix}:${benchmarkName}`;
    }

    static createStartingMarker(benchmarkName) {
      try {
        return performance.mark(`${CartPerformance.#metricName(benchmarkName)}:start`);
      } catch (e) {
        return null;
      }
    }

    static measureFromEvent(benchmarkName, event) {
      try {
        const metricName = CartPerformance.#metricName(benchmarkName);
        const startMarker = performance.mark(`${metricName}:start`, { startTime: event.timeStamp });
        performance.measure(metricName, startMarker.name);
      } catch (e) {
        /* instrumentação não deve interromper o fluxo do carrinho */
      }
    }

    static measureFromMarker(benchmarkName, startMarker) {
      try {
        if (!startMarker) return;
        performance.measure(CartPerformance.#metricName(benchmarkName), startMarker.name);
      } catch (e) {
        /* idem */
      }
    }

    static measure(benchmarkName, callback) {
      const metricName = CartPerformance.#metricName(benchmarkName);
      let startMarker = null;

      try {
        startMarker = performance.mark(`${metricName}:start`);
      } catch (e) {
        startMarker = null;
      }

      try {
        return callback();
      } finally {
        try {
          if (startMarker) performance.measure(metricName, startMarker.name);
        } catch (e) {
          /* idem */
        }
      }
    }
  }

  window.CartPerformance = CartPerformance;
}
